type MaterialUiPickersDate = any;
import dateFormat from 'dateformat';
import dayjs, { Dayjs, ConfigType } from 'dayjs';
import { replaceUntilIndex } from '../libs/strings';
const formatToReadableDate = (anyDate: string | number | Date | undefined, formatOfDate?: string) => {
    const outputStringFormat = formatOfDate || 'dd.mm.yyyy';
    return dateFormat(anyDate, outputStringFormat);
};
const afterAndBetweenMinutes = (compareToDate: number, date: string, beforeMins: number, afterMins: number) => Math.round((Date.parse(date) - compareToDate) / 60000) <= beforeMins &&
    Math.round((Date.parse(date) - compareToDate) / 60000) >= afterMins;
const beforeAndBetweenMinutes = (compareToDate: number, date: string, beforeMins: number, afterMins: number) => Math.round((compareToDate - Date.parse(date)) / 60000) <= afterMins &&
    Math.round((compareToDate - Date.parse(date)) / 60000) >= beforeMins;
/**
 * Allows to check if the date that's being compared to is either before or after specified mins
 * todo possibly edit it to allow either to be string or number
 *
 */
const betweenSpecifiedMinutes = (date: string, compareToDate: number, beforeMins: number, afterMins: number, when: 'before' | 'after' | 'both') => when === 'before'
    ? beforeAndBetweenMinutes(compareToDate, date, beforeMins, afterMins)
    : when === 'after'
        ? afterAndBetweenMinutes(compareToDate, date, beforeMins, afterMins)
        : // when === both or not defined
            beforeAndBetweenMinutes(compareToDate, date, beforeMins, afterMins) ||
                afterAndBetweenMinutes(compareToDate, date, beforeMins, afterMins);
const minutesOfDay = (date: string | number | Date | Dayjs) => {
    const d = dayjs(date);
    return d.minute() + d.hour() * 60;
};
const isWeekend = (date: string | number | Date) => new Date(date).getDay() === 6 || new Date(date).getDay() === 0;
/** checks if date is within user input timerange */
const isWithinTimeRange = (startDate: string, endDate: string, rangeStartTime: string, rangeEndTime: string, filterWeekends: boolean) => {
    if (filterWeekends) {
        return (minutesOfDay(startDate) >= minutesOfDay(rangeStartTime) &&
            minutesOfDay(endDate) <= minutesOfDay(rangeEndTime));
    }
    else {
        return isWeekend(startDate) || isWeekend(endDate)
            ? true
            : minutesOfDay(startDate) >= minutesOfDay(rangeStartTime) &&
                minutesOfDay(endDate) <= minutesOfDay(rangeEndTime);
    }
};
/** checks if date is within user input timerange,
 *
 * Accepts ISO date which ignores anything else than minutes */
const isShowingWithinTimeRange = (startDate: string, endDate: string, rangeStartTime: string, rangeEndTime: string) => minutesOfDay(startDate) >= minutesOfDay(rangeStartTime) &&
    minutesOfDay(endDate) <= minutesOfDay(rangeEndTime);
const addDays = (date: Date | string | number, days: number) => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
};
const addHours = (date: Date | string | number, hours: number) => {
    const result = new Date(date);
    result.setDate(result.getHours() + hours);
    return result;
};
// check if dd.mm of reservable is greater than current
const atLeastNextDay = (firstDateDDMM: string, nextDateDDMM: string) =>
// check if month is greater
firstDateDDMM.split('.')[1] > nextDateDDMM.split('.')[1]
    ? true
    : // if not, is day greater
        firstDateDDMM.split('.')[0] > nextDateDDMM.split('.')[0];
// check if dd.mm of reservable is greater than current
const sameDay = (firstDate: Date, nextDate: Date) => {
    // check if same date
    return (dateFormat(firstDate, 'dd.mm.yyyy') === dateFormat(nextDate, 'dd.mm.yyyy'));
};
const isInFuture = (date: number, customFutureDate?: number) => Math.round(date - (customFutureDate ? customFutureDate : Date.now())) /
    (1000 * 60 * 60) >=
    0;
const isInFutureSameTimeZone = (date: number, customFutureDate?: number) => {
    const now = dayjs();
    const nowDate = dayjs()
        .hour(now.hour())
        .minute(now.minute())
        .toISOString();
    return (Math.round(date - (customFutureDate ? customFutureDate : new Date(nowDate).getTime())) /
        (1000 * 60 * 60) >= 0);
};
const dateDifferenceMinutes = (start: any, end: any) => {
    if (start instanceof Date && end instanceof Date) {
        return Math.round((end.getTime() - start.getTime()) / 60000);
    }
    return Math.round((Date.parse(end) - Date.parse(start)) / 60000);
};
const getAmountOfTimeslots = (startDate: Date | string, endDate: Date | string, duration: number) => Math.floor(dateDifferenceMinutes(startDate, endDate) / duration);
/** date picker date format yyyy/mm/dd, replace iso date string values with them */
const replaceOldDateWithChosenDate = (datePickerDate: string, rawOldDate: string | Date) => {
    const chosenDate = datePickerDate.replace(/\//g, '-');
    const oldDate = typeof rawOldDate === 'string' ? rawOldDate : rawOldDate.toISOString();
    return replaceUntilIndex(oldDate, chosenDate, 10);
};
const formatStringIfDate = (maybeDate: string | undefined) => {
    if (!maybeDate) return maybeDate;
    // Don't treat plain numbers as dates (e.g. movingWithAmount = 2)
    if (typeof maybeDate === 'number' || /^\d{1,4}$/.test(maybeDate)) return String(maybeDate);
    const parsed = dayjs(maybeDate);
    return parsed.isValid() ? parsed.format('DD.MM.YYYY') : maybeDate;
};
const isDateChosenTimeAway = (date: ConfigType, daysFromNow: number) => {
    const chosenTimeFromNow = dayjs(Date.now()).add(daysFromNow, 'days');
    return dayjs(date).isAfter(chosenTimeFromNow, 'day');
};
const isDateWithinChosenDaysFromNow = (date: ConfigType, daysFromNow: number) => {
    const today = dayjs(Date.now());
    const withinAWeek = dayjs(Date.now()).add(daysFromNow, 'days');
    return dayjs(date).isBetween(today, withinAWeek, 'day', '[]');
};
const getDifferenceInDays = (date: ConfigType, compareToDate?: ConfigType) => {
    const d = dayjs(date);
    const comparisonDate = compareToDate
        ? dayjs(compareToDate)
        : dayjs(Date.now());
    const differenceBetween = d.diff(comparisonDate, 'days');
    return differenceBetween;
};
const getDifferenceInMinutes = (date: ConfigType, compareToDate: ConfigType) => {
    const d = dayjs(date);
    const comparisonDate = dayjs(compareToDate);
    const differenceBetween = d.diff(comparisonDate, 'minutes');
    return differenceBetween;
};
const daysInThisMonth = (date: Dayjs) => {
    return new Date(date.year(), date.month() + 1, 0).getDate();
};
const isValidDate = (date: Dayjs | Date | string | number | undefined | null) => dayjs(date).isValid();
/** Makes milliseconds and seconds 0
 *
 * Reason for using this:
 * When using MUI time picker in mobile mode, it saves seconds and milliseconds
 * even in minute precision
 *
 * Examples
 *
 * Before:
 * User picks end/start time 15 hours and 00 minutes, picker saves eg. 15:00.25.555Z
 *
 * After:
 * Picker saves 15:00.00.000Z
 *
 *
 * Fixes showing validation edge case:
 *
 * Ending time of an existing showing is 15:00.25
 * New showing could not be created with start time of 15:00.00
 **/
const formatDateToMinutePrecision = (unformattedDate: MaterialUiPickersDate) => dayjs(unformattedDate).isValid()
    ? dayjs(unformattedDate)
        .second(0)
        .millisecond(0)
    : unformattedDate;
const formatMoment = (unformattedDate: MaterialUiPickersDate, format: string) => dayjs(unformattedDate).isValid()
    ? dayjs(unformattedDate, format)
    : unformattedDate;
const arrayContainsTime = (array: Dayjs[], time: Dayjs | string): boolean => {
    let existist = false;
    array.forEach((item) => {
        if (item.format('H:mm') === dayjs(time).format('H:mm')) {
            existist = true;
        }
    });
    return existist;
};
const objectArrayContainsTime = (array: {
    startTime: Dayjs;
    endTime: Dayjs;
}[], time: Dayjs | string): boolean => {
    let existist = false;
    //here should be time validation)
    array.forEach((item) => {
        if (item.startTime.format('H:mm') === dayjs(time).format('H:mm')) {
            existist = true;
        }
    });
    return existist;
};
export { formatToReadableDate, betweenSpecifiedMinutes, isWithinTimeRange, isShowingWithinTimeRange, addDays, addHours, atLeastNextDay, isInFuture, dateDifferenceMinutes, sameDay, getAmountOfTimeslots, replaceOldDateWithChosenDate, formatStringIfDate, isDateChosenTimeAway, isDateWithinChosenDaysFromNow, getDifferenceInDays, getDifferenceInMinutes, isValidDate, formatDateToMinutePrecision, formatMoment, arrayContainsTime, objectArrayContainsTime, daysInThisMonth, isInFutureSameTimeZone };
